module.exports = __webpack_public_path__ + "static/media/40.36991e62.png";